import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flexbox } from '@morressier/ts';
import { LinkButton } from 'components/ProfileUIComponents';

export const MissingProfileIndicatorIcon = styled(FontAwesomeIcon)<{
  iconColor?: string;
}>`
  font-size: var(--fontSizes-xxl);
  line-height: var(--lineHeights-l);
  color: ${({ iconColor }) => iconColor ?? 'var(--color-teal-40)'};
`;

export const MissingProfileIndicatorContent = styled(Flexbox)<{
  backgroundColor?: string;
}>`
  border-radius: 8px;
  padding: 1rem;
  margin-top: 0.5rem;
  border: 1px solid var(--color-mono-95);
  background-color: ${({ backgroundColor }) =>
    backgroundColor ?? 'transparent'};
`;

export const MissingProfileIndicatorTextContent = styled('div')`
  padding-left: 0.1rem;
`;

export const UpdateButton = styled(LinkButton)<{
  fontWeight?: number | string;
}>`
  margin-top: 8px;
  font-weight: ${({ fontWeight }) => fontWeight ?? 'var(--fontWeights-normal)'};
`;
